module.exports = __webpack_public_path__ + "img/武汉电力.1ece283e.png";